import axiosClient from "utils";

async function fetchPlayer(params) {
  const url = `/v1/members`;
  return axiosClient.get(url, { params });
}

export { fetchPlayer };
